import NavBar from "../../components/NavBar/NavBar";
import SideBar from "../../components/SideBar/SideBar";
import UserProfile from "../../components/UserProfile/UserProfile";

import "./Settings.scss";

const Settings = () => {
  return (
    <div className="settings-outer-container">
      <NavBar />
      Settings - User Profile
      <div className="settings-outer-content-container">
        <div className="sidebar-container">
          <SideBar />
        </div>
        <UserProfile />
      </div>
    </div>
  );
};

export default Settings;
